import React from 'react';
import { TableRow, TableCell, IconButton, Box, MenuItem, Menu } from '@mui/material';
import { SupplierWithId } from '../../../models/supplier.model';
import styles from '../SupplierProfiles.module.scss';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../common/constants/routes';
import { useTranslation } from 'react-i18next';
import MoreVertIcon from '@mui/icons-material/MoreVert';

type SupplierRowProps = {
  supplier: SupplierWithId;
  navigateToDocs: (id: number) => void;
  handleEdit: (id: number) => void;
  handleDelete: (id: number) => void;
};

export const SupplierRow: React.FC<SupplierRowProps> = ({
  supplier,
  navigateToDocs,
  handleDelete,
  handleEdit,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <TableRow className={styles.table_row} key={supplier.id}>
      <TableCell
        id={`supplierRowNameCell_${supplier.id}`}
        className={styles.table_cell}
        onClick={() => navigate(`${ROUTES.SUPPLIER_PROFILES}/${supplier.id}`)}
      >
        {supplier.name}
      </TableCell>
      <TableCell
        id={`supplierRowEmailCell_${supplier.id}`}
        className={styles.table_cell}
        onClick={() => navigate(`${ROUTES.SUPPLIER_PROFILES}/${supplier.id}`)}
      >
        {supplier.supplier_email || '-'}
      </TableCell>
      <TableCell
        id={`supplierRowRegistrationNumberCell_${supplier.id}`}
        className={styles.table_cell}
        onClick={() => navigate(`${ROUTES.SUPPLIER_PROFILES}/${supplier.id}`)}
      >
        {supplier.registration_number || '-'}
      </TableCell>
      <TableCell
        id={`supplierRowPostalAddressCell_${supplier.id}`}
        className={styles.table_cell}
        onClick={() => navigate(`${ROUTES.SUPPLIER_PROFILES}/${supplier.id}`)}
      >
        {supplier.postal_address || '-'}
      </TableCell>
      <TableCell className={styles.table_cell} align='right'>
        <Box
          className={styles.actions_container}
          style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}
        >
          <IconButton
            id={`supplierRowOpenMenuIconBtn_${supplier.id}`}
            onClick={(event) => {
              event.stopPropagation();
              setAnchorEl(event.currentTarget);
            }}
            size='small'
            sx={{ p: 0.5 }}
          >
            <MoreVertIcon
              id={`supplierRowOpenMenuIconBtnMoreVertIcon_${supplier.id}`}
              fontSize='small'
            />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <MenuItem
              id={`supplierRowEditMenuItem_${supplier.id}`}
              onClick={(event) => {
                event.stopPropagation();
                setAnchorEl(null);
                handleEdit(supplier.id);
              }}
            >
              {t('buttons.edit')}
            </MenuItem>
            <MenuItem
              id={`supplierRowDocumentsMenuItem_${supplier.id}`}
              onClick={(event) => {
                event.stopPropagation();
                setAnchorEl(null);
                navigateToDocs(supplier.id);
              }}
            >
              {t('buttons.documents')}
            </MenuItem>
            <MenuItem
              id={`supplierRowDeleteMenuItem_${supplier.id}`}
              onClick={(event) => {
                event.stopPropagation();
                setAnchorEl(null);
                handleDelete(supplier.id);
              }}
            >
              {t('buttons.delete')}
            </MenuItem>
          </Menu>
        </Box>
      </TableCell>
    </TableRow>
  );
};
